<form [formGroup]="loginForm" class="container">
  <div class="row">
    <div class="col-12">
      <kendo-formfield>
        <kendo-label
          class="!k-align-items-start"
          text="Benutzername oder E-Mail"
          for="userLogin"
        ></kendo-label>
        <kendo-textbox
          showErrorIcon="initial"
          id="userLogin"
          [formControlName]="formControlNames.UserName"
        >
        </kendo-textbox>
      </kendo-formfield>

      <kendo-formfield>
        <kendo-label
          class="!k-align-items-start"
          text="Benutzername oder E-Mail"
          for="password"
        ></kendo-label>
        <kendo-textbox
          showErrorIcon="initial"
          #password
          id="password"
          [formControlName]="formControlNames.Password"
        ></kendo-textbox>
      </kendo-formfield>
    </div>
  </div>
</form>

<div class="container small-font k-mt-5">
  <div class="row">
    <div class="col-9">
      <div class="row">
        <div class="col-6">
          <input type="checkbox" #stayLoggedIn kendoCheckBox />
          <kendo-label class="k-checkbox-label" [for]="stayLoggedIn" text="Angemeldet bleiben">
          </kendo-label>
        </div>

        <div class="col-6 k-text-right" style="margin-top: 3px">
          <a href="#">Passwort vergessen?</a>
        </div>
      </div>
    </div>
  </div>

  <div class="row k-mt-5">
    <div class="col">
      <button kendoButton themeColor="base" type="submit" size="large" (click)="login()">
        Login
      </button>
    </div>
  </div>
  <div class="row k-mt-5">
    <div class="col">
      <span
        >Noch kein Konto?
        <a routerLink="" class="cursor-pointer" (click)="showRegister()">Hier registrieren.</a>
      </span>
    </div>
  </div>
</div>
